import React, { useEffect } from "react";
import { connect } from "react-redux";
import { ApplicationState } from "../store";
import { Categories, MenuTextData } from "../models/types";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import { Box, Grid, ListItemIcon, ListItemText } from "@material-ui/core";
import { Link } from "react-router-dom";
import { searchCategories } from "../store/products/action";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    grow: {
      flexGrow: 1,
    },
    menuItem: {
      border: "solid",
      borderRadius: "4px",
      borderColor: "#ebdcc4",
      borderWidth: "thin",
      boxShadow: "none",
      "&:hover": {
        backgroundColor: "#FFF"
      }
    },
    menuItemLink: {
      fontSize: "12px",
      color: "#000000",
      textDecoration: "none"
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    categoryBox: {
        color: '#000000',
        fontSize: 16,
        fontWeight: 'bold'
    }
  }),
);

interface IProps {
    id?: string;
    title?: string;
}

interface PropsFromState {
  language: string;
  text: MenuTextData;
  textLoading: boolean;
  loading: boolean;
  categories: Categories[];
}

interface propsFromDispatch {
    searchCategories: (id?: string) => any;
}

type AllProps = IProps & PropsFromState & propsFromDispatch;

const ProductCategories: React.FC<AllProps> = ({
  id,
  title,
  language,
  text,
  textLoading,
  loading,
  categories,
  searchCategories
}) => {
  useEffect(() => {
    searchCategories(id || '');
  }, [id, searchCategories]);

  const classes = useStyles();

  return (
    <Box pt={2} pb={1} pl={2} pr={2} className={classes.categoryBox}>
      {title ? (
          <Box pb={2}><FormattedMessage id={title} /></Box>
      ) : ( null )}
      <Grid
        container
        spacing={3} 
        direction="row"
        justify="center"
      >
            {!loading&&!textLoading ? categories.map(item => (
            <Grid item xs={12} sm={6} md={4}>
              <Link to={"/product/category/" + item.code} className={classes.menuItemLink}>
                <MenuItem className={classes.menuItem}>
                  <ListItemIcon>
                    <img src={process.env.REACT_APP_IMAGE_HOST+'/files/menu_pictures/' + text[item.code]?.image || ''} alt={text[item.code]?.value[language]} width="30px" />
                  </ListItemIcon>
                  <ListItemText primary={text[item.code]?.value[language]}></ListItemText>
                </MenuItem>
              </Link>
            </Grid>
            )) : ( null )}
        </Grid>
        </Box>   
  );
};

const mapStateToProps = ({ menu, products, language }: ApplicationState) => ({
  text: menu.text,
  textLoading: menu.loading,
  language: language.language,
  loading: products.categoriesLoading,
  categories: products.categories
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    searchCategories: (id?: string) => {
      dispatch(searchCategories(id));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductCategories);
